import * as React from 'react'

import DialogActions  from '@material-ui/core/DialogActions/DialogActions'
import DialogContent  from '@material-ui/core/DialogContent'
import { withFormik } from 'formik'

import { Program }                                   from '../../api'
import { ActionButton, InlineError, LoadingOverlay } from '../atoms'
import { FullScreenDialog }                          from '../molecules'
import { CompanyChunk }                              from './chunks'
import {
  genValueMapper,
  proxyFormikSubmission,
}                                                    from './form-utils'
import {
  companyEditSchema,
  emptyEditCompany,
}                                                    from './schemas'

const Form = withFormik<any, Program>({
  validationSchema: companyEditSchema,
  mapPropsToValues: genValueMapper(emptyEditCompany),
  handleSubmit:     proxyFormikSubmission,
})(
  ({
    error,
    handleSubmit,
    ...rest
  }) => (
    <form onSubmit={handleSubmit}>
      <DialogContent>
        <CompanyChunk
          mode={'edit'}
          {...rest}
        />
      </DialogContent>
      {error && (
        <DialogContent>
          <InlineError i18nErrorId={error} />
        </DialogContent>
      )}
      <DialogActions>
        <ActionButton
          type={'submit'}
          actionType={'submit'}
          variant={'raised'}
          color={'secondary'}
        />
      </DialogActions>
    </form>
  )
)

const CompanyEditForm = props => {
  const {
    fetching,
    isOpen,
    close,
    ...rest
  } = props

  return (
    <FullScreenDialog
      close={close}
      isOpen={isOpen}
      title={'editCompany'}
    >
      <LoadingOverlay show={fetching}>
        <Form {...rest} />
      </LoadingOverlay>
    </FullScreenDialog>
  )
}

export default CompanyEditForm



// WEBPACK FOOTER //
// ./src/components/forms/CompanyEditForm.tsx